export default function isNetworkError(error: { type?: string; message?: string }) {
  return error.type === 'fetch_error' || error.message === 'Network Error'
}
